import type { LocationLanguage } from './types'

export const LOCATION_LANGUAGES: LocationLanguage[] = ['pt-BR', 'en', 'es']

// The single source of truth for the app's default language — used both as `I18nProvider`'s own
// `defaultLanguage` fallback and by any consumer that needs a language to fall back to before
// Tolgee resolves one (e.g. `useCurrentLanguage()` returning `undefined` on an early render).
export const DEFAULT_LOCATION_LANGUAGE: LocationLanguage = 'pt-BR'
